var t = require('i18n').t
var NOTIFICATION_KEYS = require('../notificationKeys')

var MIN_PASSWORD_LENGTH = 8

var passwordRequirements = {
    minimumLength: function(password) {
        return password.length >= MIN_PASSWORD_LENGTH
    },
    lowercaseLetter: function(password) {
        return /[a-z]/.test(password)
    },
    uppercaseLetter: function(password) {
        return /[A-Z]/.test(password)
    },
    number: function(password) {
        return /\d/.test(password)
    },
    specialCharacter: function(password) {
        return /[^A-Za-z0-9]/.test(password)
    }
}

function passwordIsValid(password) {
    password = password || ''

    return Object.keys(passwordRequirements).every(function(requirement) {
        return passwordRequirements[requirement](password)
    })
}

function passwordRequirementIsMet(requirement) {
    return function() {
        return requirement(this.get('model.password') || '')
    }.property('model.password')
}

module.exports = Em.ObjectController.extend({
    supportUrl: t('support_url'),

    passwordHasMinimumLength: passwordRequirementIsMet(passwordRequirements.minimumLength),
    passwordHasLowercaseLetter: passwordRequirementIsMet(passwordRequirements.lowercaseLetter),
    passwordHasUppercaseLetter: passwordRequirementIsMet(passwordRequirements.uppercaseLetter),
    passwordHasNumber: passwordRequirementIsMet(passwordRequirements.number),
    passwordHasSpecialCharacter: passwordRequirementIsMet(passwordRequirements.specialCharacter),
    passwordHasValue: function() {
        return !!this.get('model.password')
    }.property('model.password'),

    actions: {
        changePassword: function() {
            var self = this
            var model = this.get('model')

            if (!passwordIsValid(model.get('password'))) {
                return
            }

            this.get('model')
                .save('/user/passwordReset', {
                    root: 'passwordReset'
                })
                .mask()
                .on('success', function(payload) {
                    self.container.lookup('api:billy').authorize(payload.meta.accessToken)
                    self.container.lookup('util:notification').notify(NOTIFICATION_KEYS.PASSWORD_CHANGE, t('password_reset.password_changed_successfully'))
                    self.replaceRoute('user')
                })
        }
    }
})
